/**
 * Standings-over-time chart for the AI League tab.
 *
 * Synthesises per-matchday history from AI model lists + optional user roster,
 * then renders the same StandingsChartPanel used on LeaguePage.
 */
import { Box, Text } from '@chakra-ui/react';

import type { AiModelContent } from '@/constants/aiLeague/aiLeagueTypes';
import { StandingsChartPanel } from '@/components/standingsChart/StandingsChartPanel';
import type { AiLeagueChartUserInput } from '@/hooks/useAiLeaguePageData';
import type { gameResult } from '@/models/gameUpdate';
import { pageSectionTitleProps } from '@/theme/sitePageTypography';
import { Card } from '@/views/LeaguePage/Card';
import { useAiLeagueStandingsData } from './useAiLeagueStandingsData';

export interface AiLeagueStandingsChartSectionProps {
  gameResults: gameResult[];
  settledMatchday: number;
  aiModels: AiModelContent[];
  chartUser?: AiLeagueChartUserInput;
}

export function AiLeagueStandingsChartSection(props: AiLeagueStandingsChartSectionProps) {
  const { standings, columns, ready, currentUid, gameResults } = useAiLeagueStandingsData(props);

  if (!ready) {
    return null;
  }

  return (
    <Box id='standings-chart' w='full'>
      <Card w='full' borderRadius='md' p={{ base: 3, md: 4 }}>
        <Text {...pageSectionTitleProps} mb={2}>
          Points over time
        </Text>
        <StandingsChartPanel
          embedded
          series={standings.series}
          maxMatchday={standings.maxMatchday}
          columns={columns}
          currentUid={currentUid}
          gameResults={gameResults}
        />
      </Card>
    </Box>
  );
}
